import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocale } from '../i18n/LocaleContext';
import { SUPPORTED_LANGUAGES, localePath } from '../i18n';

const SITE_ORIGIN = 'https://softup.agency';

/**
 * Tells search engines that the English and Arabic versions of a page are
 * translations of each other, so an Arabic search surfaces the /ar URL rather
 * than treating it as duplicate content.
 */
export default function HreflangTags() {
  const { lang, canonicalPath } = useLocale();

  return (
    <Helmet>
      <html lang={lang} />
      <link rel="canonical" href={`${SITE_ORIGIN}${localePath(canonicalPath, lang)}`} />
      {SUPPORTED_LANGUAGES.map((code) => (
        <link
          key={code}
          rel="alternate"
          hrefLang={code}
          href={`${SITE_ORIGIN}${localePath(canonicalPath, code)}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${SITE_ORIGIN}${localePath(canonicalPath, 'en')}`}
      />
    </Helmet>
  );
}
